export const MAX_EXPORT_DIMENSION = 16_384;
export const MAX_EXPORT_PIXELS = 64_000_000;

export interface PixelLimitResult {
  safe: boolean;
  width: number;
  height: number;
  pixels: number;
  suggestedScale?: 1 | 2;
}

export function calculatePixelLimit(
  width: number,
  height: number,
  scale: 1 | 2 | 3,
): PixelLimitResult {
  const outputWidth = Math.ceil(width * scale);
  const outputHeight = Math.ceil(height * scale);
  const pixels = outputWidth * outputHeight;
  const safe =
    outputWidth <= MAX_EXPORT_DIMENSION &&
    outputHeight <= MAX_EXPORT_DIMENSION &&
    pixels <= MAX_EXPORT_PIXELS;
  if (safe) return { safe, width: outputWidth, height: outputHeight, pixels };
  const suggestedScale = ([2, 1] as const).find((candidate) => {
    const w = Math.ceil(width * candidate);
    const h = Math.ceil(height * candidate);
    return w <= MAX_EXPORT_DIMENSION && h <= MAX_EXPORT_DIMENSION && w * h <= MAX_EXPORT_PIXELS;
  });
  return { safe, width: outputWidth, height: outputHeight, pixels, suggestedScale };
}
